import React from 'react';
import { Row, Col } from 'tea-component';

import StoreRanksTopCommcard from '../StoreRanksTopCommcard';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

import {
  analysisPlatformTopInfo,
  getStoreRankTopName,
  getStoreRankTopSubTitle,
} from '@/pages/intelligence/_config/storeRank/utils';

import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IStoreRankTop, IStoreRankTopRank } from '@/pages/intelligence/types/storeRank';

interface IStoreRanksTopCommcardListProps extends IBaseProps {
  entityType: 'mobile' | 'pc' | 'console' | 'minigame';
  gameIdKey: string;
  tops: IStoreRankTop[];
  // 榜单的无游戏rank数据UI renderer
  noDataRenderer?: (payload: { source: string; lastDate: string }) => React.ReactElement;
  onCardTitleClick?: (payload: IStoreRankTop) => void;
  onCardGameClick?: (
    topPayload: IStoreRankTop,
    topRankPayload: IStoreRankTopRank,
    isValidGameId: boolean,
    e: React.SyntheticEvent<HTMLElement>,
  ) => void;
  getDetailGamePath?: (
    topPayload: IStoreRankTop,
    topRankPayload: IStoreRankTopRank,
    isValidGameId: boolean,
  ) => string;
}

const StoreRanksTopCommcardList: React.FC<IStoreRanksTopCommcardListProps> = (props) => {
  const { entityType, gameIdKey, tops, noDataRenderer, onCardTitleClick, onCardGameClick, getDetailGamePath, isShowMarketIcon } = props;
  const { formatMessage } = useIntlExtend();
  if (!tops?.length) return null;

  return (
    <Row className="dbi-alltopcharts-list">
      {tops?.map((top) => {
        const { name } = top ?? {};
        const { top: topName } = analysisPlatformTopInfo(name);
        return (
          <Col key={top?.name} span={8}>
            <StoreRanksTopCommcard
              entityType={entityType}
              gameIdKey={gameIdKey}
              title={getStoreRankTopName(entityType, topName, formatMessage)}
              subTitle={getStoreRankTopSubTitle(entityType, name, formatMessage)}
              source={name}
              lastDate={top?.last_date}
              list={top?.list}
              noDataRenderer={noDataRenderer}
              onTitleClick={(e) => {
                e?.stopPropagation();
                e?.preventDefault();
                onCardTitleClick?.(top);
              }}
              onClick={(payload: IStoreRankTopRank, isValidGameId, e) => {
                onCardGameClick?.(top, payload, isValidGameId, e);
              }}
              getDetailGamePath={(payload: IStoreRankTopRank, isValidGameId) => {
                return getDetailGamePath?.(top, payload, isValidGameId) || '';
              }}
              isShowMarketIcon={isShowMarketIcon}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default StoreRanksTopCommcardList;
